import React from 'react';
import BaseForm from "../forms/BaseForm";


export default class BaseModal extends React.PureComponent {

    render() {
        return (
            <div className={`modal ${this.props.visible ? 'is-active' : ''}`}>
                <div className="modal-background"/>
                <div className="modal-card"
                     style={this.props.cardStyle ? this.props.cardStyle : {}}
                >
                    <div className="modal-card-body">
                         {/*style={this.props.wide ? {width: '70vw'} : {}}>*/}
                        {this.props.children}
                    </div>
                </div>
                {this.props.onClose &&
                    <button className="modal-close is-large" aria-label="close" onClick={this.props.onClose}/>
                }
            </div>
        )
    }

}
